import { render } from "./GovernmentMaster.vue?vue&type=template&id=2a4b9092&scoped=true"
import script from "./GovernmentMaster.vue?vue&type=script&lang=js"
export * from "./GovernmentMaster.vue?vue&type=script&lang=js"

import "./GovernmentMaster.vue?vue&type=style&index=0&id=2a4b9092&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4b9092"]])

export default __exports__